import { TextField, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Typography, useMediaQuery, useTheme, InputAdornment, } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import ClearIcon from '@mui/icons-material/Clear';
import { cloneDeep, omit, pick } from "lodash";
import { ConfirmDialog, PhoneInput } from "modules/common";
import runJoiValidate from "utils/runJoiValidate";
import { DRIVER_SCHEMA_WITHOUT_PASSWORD, DRIVER_SCHEMA } from "../ValidationSchemas";

export default function DriverDialog({
    openDriverDialog,
    loading,
    isEditing,
    driver,
    handleChange,
    onCreateDriver,
    onUpdateDriver,
    onDeleteDriver,
    onCloseDialog,
    error,
    isSuccess
}) {
    const { t } = useTranslation()
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [validationErrors, setValidationsErrors] = useState(null);
    //const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = () => {
        setValidationsErrors(null)
        let payload = pick(cloneDeep(driver), ["name", "phone", "password"])
        let errors = null
        if (isEditing && !payload?.password) {
            payload = omit(payload, ["password"])
            errors = runJoiValidate(DRIVER_SCHEMA_WITHOUT_PASSWORD, payload)
        } else {
            errors = runJoiValidate(DRIVER_SCHEMA, payload)
        }
        if (!!errors) {
            setValidationsErrors(errors)
            return
        }
        if (isEditing) {
            onUpdateDriver({ id: driver?.id, payload })
        } else {
            onCreateDriver(payload)
        }
    }

    return (
        <Dialog
            maxWidth="md"
            dir={theme.direction}
            fullWidth
            fullScreen={fullScreen}
            open={openDriverDialog}
            aria-labelledby="driver-dialog-title"
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {`${isEditing ? t('Edit driver') : t('Add driver')}`}
                <IconButton onClick={onCloseDialog} color="primary">
                    <ClearIcon />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={5} alignItems="center">
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            name="name"
                            value={driver?.name ?? ""}
                            onChange={handleChange}
                            helperText={validationErrors?.name ?? ''}
                            error={!!validationErrors?.name}
                            label={t("Full Name")} size="small" variant="outlined" margin="normal" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <PhoneInput
                            sx={{ mt: 8 }}
                            label={t("Phone")}
                            size="small"
                            name="phone"
                            fullWidth
                            value={driver?.phone ?? ""}
                            onChange={handleChange}
                            error={validationErrors?.phone ?? ""}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            value={driver?.password}
                            onChange={handleChange}
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label={t("Password")}
                            // type={showPassword ? 'text' : 'password'}
                            // InputProps={
                            //         {
                            //             endAdornment: <InputAdornment position="end">
                            //                 {
                            //                     showPassword ?
                            //                         <IconButton onClick={() => setShowPassword(false)}>
                            //                             <Visibility />
                            //                         </IconButton>
                            //                         :
                            //                         <IconButton onClick={() => setShowPassword(true)}>
                            //                             <VisibilityOff />
                            //                         </IconButton>
                            //                 }
                            //             </InputAdornment>,
                            //         }
                            // }
                            error={!!validationErrors?.password}
                            helperText={validationErrors?.password}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <Divider />
            <DialogActions
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: 'row-reverse'
                }}>
                <Box>
                    <LoadingButton
                        size="small"
                        variant="contained"
                        disableElevation
                        onClick={handleSubmit}
                        loading={loading}
                        sx={{
                            textTransform: "none",
                            fontWeight: "bold",
                            mr: 5
                        }}
                    >
                        {isEditing ? t("Edit") : t("Add")}
                    </LoadingButton>
                    {isEditing &&
                        <LoadingButton
                            onClick={() => setOpenConfirmDialog(true)}
                            loading={loading}
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none" }}
                            size="small"
                        >
                            {t("Delete")}
                        </LoadingButton>
                    }
                </Box>
                <Box>
                    {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
                    {!!error && <Typography color="error">{t(error)}</Typography>}
                </Box>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        textTransform: "none",
                        fontWeight: "bold",
                    }}
                    onClick={onCloseDialog}>
                    {t("Close")}
                </Button>
            </DialogActions>
            <ConfirmDialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}
                title={t("Warning")}
                content={t("Are you sure you want to delete it?")}
                confirmFn={() => {
                    onDeleteDriver(driver.id)
                    setOpenConfirmDialog(false)
                }}
            />
        </Dialog>
    )
}